import { useEffect, useState } from 'react';

import { useBlockNumber } from 'wagmi';

import * as S from './BlockCounter.styles';
//

const BLOCK_TIME_MS = 2000;
const MAX_SIMULATE_MS = 15_000;

export const BlockCounter = () => {
  const blockNumber = useBlockNumber({
    chainId: 137,
    query: { refetchInterval: 10_000 },
  });

  const [, tick] = useState(0);

  useEffect(() => {
    const id = setInterval(() => tick((n) => n + 1), BLOCK_TIME_MS);
    return () => clearInterval(id);
  }, []);

  const formatNumber = (num: number): string => num.toLocaleString('en-US');

  let displayBlock = '...';
  if (blockNumber.data !== undefined && blockNumber.dataUpdatedAt) {
    const elapsed = Date.now() - blockNumber.dataUpdatedAt;
    const increment = Math.floor(Math.min(elapsed, MAX_SIMULATE_MS) / BLOCK_TIME_MS);
    displayBlock = formatNumber(Number(blockNumber.data) + increment);
  }

  return (
    <S.Container>
      <S.Label>BLOCK</S.Label>
      <S.Row>
        <S.Value>{displayBlock}</S.Value>
      </S.Row>
    </S.Container>
  );
};
